var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeLider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.8085C14.4368 12.8085 17.2222 9.99629 17.2222 6.52644C17.2222 3.05658 14.4368 0.244385 11 0.244385C7.56317 0.244385 4.77775 3.05658 4.77775 6.52644C4.77775 9.99629 7.56317 12.8085 11 12.8085ZM15.6569 14.4084L13.3333 23.8021L11.7778 17.1274L13.3333 14.379H8.66664L10.2222 17.1274L8.66664 23.8021L6.34303 14.4084C2.87706 14.5753 0.111084 17.4366 0.111084 20.9752V23.0168C0.111084 24.3174 1.15622 25.3726 2.44442 25.3726H19.5555C20.8437 25.3726 21.8889 24.3174 21.8889 23.0168V20.9752C21.8889 17.4366 19.1229 14.5753 15.6569 14.4084Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLider);
export default __webpack_public_path__ + "static/media/IconeLider.80f5f4a831e90d9b8187712af33ba6b2.svg";
export { ForwardRef as ReactComponent };